<template>
  <div class="main-con el-main">
    <nav-breadcrumb :menu="[{label: '逾期贷款报表'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="listData"
        :columns="listColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
        :actions="actions"
      ></data-table>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import {formatMoney} from "../../../filters/CommonFilters";

  export default {
    name: 'ReportingOverdueList',
    data() {
      return {
        transactionStatus: this.$route.query['fi.transactionStatus'],
        page: 1,
        pageSize: 10,
        listData: {},
        listColumns: [
          {
            name: '序号',
            type: 'index'
          },
          {
            name: '贷款编号',
            field: 'fi__transactionNo'
          },
          {
            name: '客户姓名',
            field: 'i__contactPerson'
          },
          {
            name: '手机号',
            field: 'i__contactTelNo'
          },
          {
            name: '贷款金额',
            field: 'fi__totalAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '贷款状态',
            field: 'fi__transactionStatus',
            formatter: function (r,c,v) {
              return Status2CN('Financing_'+v)
            }
          },
          {
            name: '未还本金',
            field: 'bal__principalAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '到期日',
            field: 'fi__endDate'
          },
          {
            name: '应收本金(元)',
            field: 'bal__principalAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '应收利息(元)',
            field: 'bal__interestAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '本息合计(元)',
            field: 'bal__repayAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '服务费(元)',
            field: 'bal__lendingFeeAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '其它费用(元)',
            field: 'bal__otherAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '逾期天数(天)',
            field: 'bal__overdueDays'
          },
          {
            name: '逾期罚息(元)',
            field: 'bal__overdueFine',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          }
        ],
        filters: {
          form: {
            fi__endDate: [],
          },
          columns: [
            {
              label: '逾期日期',
              component: 'date-range-picker',
              field: 'fi__endDate',

            },
          ],
          onSubmit:()=>{
            this.page = 1
            this.getReportingOverdueList()
          }
        },
        actions: [
          {
            label: '导出',
            class: 'el-icon-download el-button--primary',
            clickHandler:()=>{
              let routeData = this.$router.resolve({
                path: '/ix/reporting/Overdue.List?format=xlsx',
                query: Object.assign({}, this.filterParams, xmlBuildQuery(this.filters))
              });
              window.open(routeData.href.replace('#/', '/'), '_blank');
            }
          }
        ]
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            // 'xlist.sort.dataField': 'fi.transactionDate',
            // 'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getReportingOverdueList()
      }
    },
    mounted() {
      this.getReportingOverdueList()
    },
    methods: {
      getReportingOverdueList: function () {
        xhr.getReportingOverdueList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
            try {
              this.listData = res.data
            }catch(e){

            }
          })

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Reporting/ReportingOverdueList.vue